"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetManager = exports.WidgetEvent = void 0;
var lodash_1 = __importDefault(require("lodash"));
var EditorTypes_1 = require("./EditorTypes");
var slate_react_1 = require("slate-react");
var WidgetEvent = (function (_super) {
    __extends(WidgetEvent, _super);
    function WidgetEvent(widget, data) {
        var _this = _super.call(this, EditorTypes_1.EventType.Widget) || this;
        _this.data = {
            widget: widget,
        };
        if (data) {
            _this.data = lodash_1.default.extend(data, _this.data);
        }
        return _this;
    }
    Object.defineProperty(WidgetEvent.prototype, "action", {
        get: function () {
            var _a;
            return (_a = this.data.action) !== null && _a !== void 0 ? _a : this.data.eventType;
        },
        enumerable: false,
        configurable: true
    });
    return WidgetEvent;
}(EditorTypes_1.CustomEvent));
exports.WidgetEvent = WidgetEvent;
var WidgetManager = (function () {
    function WidgetManager(onEvent, editor, di, canEdit, projectStore) {
        this.editor = editor;
        this.onEvent = onEvent;
        this.di = di;
        this.canEdit = canEdit;
        this.isInTemplate = function () {
            return projectStore.isTemplate;
        };
    }
    WidgetManager.prototype.updateEditor = function (editor) {
        this.editor = editor;
    };
    WidgetManager.prototype.triggerEvent = function (event) {
        var editor = this.editor;
        if (!this.onEvent(event, editor)) {
            throw new WidgetEventNotHandledError(event);
        }
    };
    WidgetManager.prototype.getPath = function (element) {
        return slate_react_1.ReactEditor.findPath(this.editor, element);
    };
    return WidgetManager;
}());
exports.WidgetManager = WidgetManager;
var WidgetEventNotHandledError = (function (_super) {
    __extends(WidgetEventNotHandledError, _super);
    function WidgetEventNotHandledError(event) {
        return _super.call(this, "Widget event of widget: ".concat(event.data.widget, ", action: ").concat(event.action, " was not handled by the router; make sure a receiver of the event is wired up to the router correctly and returns truthy")) || this;
    }
    return WidgetEventNotHandledError;
}(Error));
